"use strict";

var _regeneratorRuntime = require("C:\\Users\\Csongi\\AppData\\Roaming\\npm\\node_modules\\react-scripts\\node_modules\\@babel\\runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _google = require("@react-oauth/google");

var _formFiledModule = _interopRequireDefault(require("../styles/form-filed.module.css"));

var _baseModule = _interopRequireDefault(require("../styles/base.module.css"));

var _btn_google_light_normal_ios = _interopRequireDefault(require("../imgs/btn_google_light_normal_ios.svg"));

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var GoogleButton = function GoogleButton(_ref) {
  var onFinished = _ref.onFinished,
      disabled = _ref.disabled,
      type = _ref.type;
  var login = (0, _google.useGoogleLogin)({
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(tokenResponse) {
        var userInfo;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _axios.default.get('https://www.googleapis.com/oauth2/v3/userinfo', {
                  headers: {
                    Authorization: "Bearer ".concat(tokenResponse.access_token)
                  }
                });

              case 2:
                userInfo = _context.sent;

                if (userInfo.status === 200) {
                  onFinished(_objectSpread({}, userInfo.data, {
                    access_token: tokenResponse.access_token
                  }));
                } else {
                  onFinished(null);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onSuccess(_x) {
        return _onSuccess.apply(this, arguments);
      }

      return onSuccess;
    }(),
    onError: function onError(errorResponse) {
      console.log(errorResponse);
      onFinished(null);
    }
  });
  return _react.default.createElement("button", {
    onClick: login,
    disabled: disabled,
    className: "".concat(_formFiledModule.default.button, " ").concat(_baseModule.default.googleButton)
  }, _react.default.createElement("span", {
    style: {
      backgroundImage: "url(".concat(_btn_google_light_normal_ios.default, ")")
    }
  }), _react.default.createElement("span", null, "".concat(type === 'login' ? 'Login' : 'Continue', " with Google")));
};

var _default = GoogleButton;
exports.default = _default;